﻿import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useUpdateFeature = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [updateSubscriptionFeature, { loading, data }] = useMutation<any>(
    mutations.updateSubscriptionFeature,
    {
      onCompleted: (response) => {
        if (response.updateSubscriptionFeature?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    updateSubscriptionFeature,
    loading,
    success,
    data,
    resetForm,
  };
};
